export default __webpack_public_path__ + "static/media/paytrie_walkthrough_3.752ece6c.bin";